import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { Link, Redirect, RouteComponentProps, withRouter } from "react-router-dom";

import Loading from "components/Loading";
import Config, { hasFeature } from "config";
import { State } from "state";
import { login, postLogin, resetPassword } from "state/auth";
import { isIe } from "utils/helpers";
import Card from "@material-ui/core/Card";
import Button from "@material-ui/core/Button";
import LoginBackground from "assets/img/login-background-v4.png";
import ResetIQLogo from "assets/img/Reset IQ - Powered By A-B.png";
import Loader from "components/Loader";
import UserCreationRequestModal from "components/UserCreationRequestModal";
import { showSearchEmailModal, showUserCreationModal } from "state/request";
import TrackRequestModal from "components/request/TrackRequestModal";
import RequestDetailsModal from "components/request/RequestDetailsModal";

type ILoginProps = RouteComponentProps<{}> & PropsFromRedux;

class SignIn extends React.Component<ILoginProps> {
  public ieEnabled = hasFeature(Config.FEATURES, "IE");

  public renderLoading = () => {
    return (
      <div className="signin-loading-container">
        <Loading color={"#fff"} />
      </div>
    );
  };

  public render() {
    let { from = { pathname: "/" } } = this.props.location.state;
    if (sessionStorage.getItem('redirectedPath'))
      from = sessionStorage.getItem('redirectedPath')
    // const from = this.props.location.state?.from?.pathname || sessionStorage.getItem('redirectedPath')
    const { user, auth } = this.props;

    let errorMessage: string = "Unable to login. Please check your credentials and try again.";

    if (isIe && !this.ieEnabled) {
      errorMessage =
        "Internet Explorer is not supported by Reset IQ. Relaunch the application in Google Chrome.";
    } else if (typeof auth.error && String(auth.error).indexOf("401") !== -1) {
      // If we get here, that means the B2C login suceeded, but there is no account in the DB.
      errorMessage =
        "Account not activated on Reset IQ. Contact ResetIQComms@Anheuser-Busch.com if you believe you should have access.";
    } else if (auth.content !== undefined) {
      errorMessage = auth.content;
    }

    if (!auth.hasError && user.content && auth.content) {
      this.props.postLogin();
      const redirectPath = sessionStorage.getItem('redirectedPath') || '/associated-chains';
      sessionStorage.removeItem('redirectedPath');
      return <Redirect to={redirectPath} />;
    }

    return (
      <div>
        {auth.loading || user.loading ? (
          <div>
            <Loader paddingTop="250px"></Loader>
          </div>
        ) : (
          <div>
            {LoginBackground && ResetIQLogo && (
          <section className="signin-container">
        <Card className="inner-signin-container" variant="elevation" style={{ backgroundColor: 'rgb(227, 189, 33, 0.25)', width: '550px', height: '423px', borderRadius: '16px'}}>
          <div style={{width: '38%', height: '12%', margin: 'auto', display: 'flex', justifyContent: 'center', marginTop: '115px', marginLeft: '165px'}}>
          <div style={{ display: "flex", gap: "0.75rem" }}>
        {/* <img src={ResetIQLogo} alt="" /> */}
        <div
          style={{
            width: '279px',
            margin: "-45px auto 16px auto",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <img
            src={ResetIQLogo}
            alt="Reset IQ Logo"
            style={{
              width: "100%",
              height: "auto",
              display: "block"
            }}
          />
        </div>

        {/*<h1 style={{ fontSize: '31px', fontWeight: 600, margin: 0, color: 'black', width: '212px',  }}>BREW BOX</h1>*/}
      </div>
          </div>
          <div style={{width: '50%', height: '12%', margin: 'auto', display: 'flex', justifyContent: 'center', marginTop: '16px'}}>
          <Button style={{backgroundColor: '#E5B611', width: '297px', height: '32px'}} onClick={() => this.props.login()}>
            Sign In
          </Button>
          </div>
          <div style={{justifyContent: 'space-between', display: 'flex', width: '50%', margin: 'auto'}}>
            <Link style = {{textDecoration: 'underline', fontWeight: 400, fontStyle: 'normal', fontSize: '12px', lineHeight: '20px', letterSpacing: 0, color: 'black'}} to="#" data-qa="reset-password-link" onClick={() => this.props.resetPassword()}>Reset Password</Link>
            <Link style = {{ fontWeight: 'bold', fontStyle: 'normal', fontSize: '12px', lineHeight: '20px', letterSpacing: 0, color: 'black'}} to="#" data-qa="reset-password-link" onClick={() => this.props.showUserCreationModal()}>Create New Account</Link>
          </div>
          <div style={{justifyContent: 'center', display: 'flex'}}>
          <span style={{width: '50%',  marginTop: '8px', fontWeight: 400, fontStyle: 'regular', fontSize: '11px', lineHeight: '16px', letterSpacing: 0}}>By submitting this form, you agree to be bound by the terms of service and privacy policy about Reset IQ</span>
          </div>
          <div style={{justifyContent: 'center', display: 'flex', marginTop: '16px'}}>
              <a
              style={{
                textDecoration: 'underline',
                fontWeight: 400,
                fontStyle: 'normal',
                fontSize: '11px',
                lineHeight: '20px',
                letterSpacing: 0,
                color: 'black',
                whiteSpace: 'nowrap'
              }}
              rel="noopener noreferrer"
              target="_blank"
              href="https://reset-iq.zendesk.com/hc/en-us/requests/new?"
            >
              Need Reset IQ Support? Click Here
            </a>
          </div>
          {/* <div style={{justifyContent: 'center', display: 'flex', marginTop: '16px'}}>
            <Link style = {{textDecoration: 'underline', fontWeight: 400, fontStyle: 'normal', fontSize: '11px', lineHeight: '20px', letterSpacing: 0, color: 'black'}} rel="noopener noreferrer" target="_blank" to="https://brewbox360.zendesk.com/hc/en-us/requests/new?ticket_form_id=25271446273556" >Need Reset IQ Support? Click Here</Link>
          </div> */}
          <div style={{justifyContent: 'center', display: 'flex', marginTop: '8px'}}>
            <Link style = {{textDecoration: 'underline', fontWeight: 'bold', fontStyle: 'normal', fontSize: '12px', lineHeight: '20px', letterSpacing: 0, color: 'black'}} to="#" data-qa="reset-password-link" onClick={() => this.props.showSearchEmailModal()}>Track New Request</Link>
          </div>
        </Card>
      </section>
        )}
          </div>
        )}
        <RequestDetailsModal />
        <UserCreationRequestModal />
        <TrackRequestModal />
      </div>
    );
  }
}

const connecter = connect(
  (state: State) => ({
    auth: state.auth,
    user: state.auth_user,
  }),
  { login, resetPassword, postLogin, showUserCreationModal, showSearchEmailModal }
);

type PropsFromRedux = ConnectedProps<typeof connecter>;

export default withRouter(connecter(SignIn));
